// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1__d888a183922d74a553e3{/*!*/}.Timer-cls2__bb39d49f6b3f7f5a75ce{color:#fff;font-weight:500;font-size:10px;letter-spacing:.16em;margin:0;text-align:center;text-transform:uppercase}.Timer-cls2__bb39d49f6b3f7f5a75ce.Timer-mini___15b912330deb445c8ed{font-size:8px}.Timer-cls2__bb39d49f6b3f7f5a75ce.Timer-dark__ce119506b445a22760aa{color:#4b4b4b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1__d888a183922d74a553e3",
	"cls2": "Timer-cls2__bb39d49f6b3f7f5a75ce Timer-cls1__d888a183922d74a553e3",
	"mini": "Timer-mini___15b912330deb445c8ed",
	"dark": "Timer-dark__ce119506b445a22760aa"
};
export default ___CSS_LOADER_EXPORT___;
